export function getDataAttr(element,attribute){return element.getAttribute("data-"+attribute)}export default getDataAttr;